<!-- Translated: skip -->
<template>
  <div :class="{component: true, 'waiting-for-filter': isAwaitingFilter}">

    <!-- Normal search -->
    <transition-group name="animate-list" class="animate-list" tag="ul" v-if="!$store.state.accomodationsFilter.freeSearch" aria-label="Lista över boendeområden">
      <li :key="-2" :class="'animate-list-item no-results result-count-0'" v-if="!SITE_CONFIG.modules_open.accomodation.open">
        <b>Stängt</b>
        <p>{{SITE_CONFIG.modules_open.accomodation.closed_message}}</p>
      </li>
      <li v-for="(pool, index) in filteredPools" :key="pool.id" class="animate-list-item area-wrapper" :aria-label="'Område: ' + (pool.display_name || pool.name)">

        <!-- <div class="site-label" v-if="showLocationLabel && (index === 0 || filteredPools[index - 1].units[0].facility_id !== pool.units[0].facility_id)">
          <span v-if="pool.units[0].facility && locations[pool.units[0].facility.id]">
            {{locations[pool.units[0].facility.id].title}}
          </span>
          <span v-else>
            Övriga
          </span>
        </div> -->

        <div class="list-header" v-if="areaTitle(pool, index)">
          <span>{{ areaTitle(pool, index) }}</span>
        </div>

        <AccomodationsListPool :pool="pool" :locations="locations"></AccomodationsListPool>
      </li>
      <li :key="-1" :class="'animate-list-item no-results result-count-' + filteredPools.length" role="note">
        <strong>Dina filterval gav ingen träff</strong>
        <p>Dina filterval gav ingen träff, ta bort filter eller återställ och börja om.</p>
      </li>
    </transition-group>

    <!-- Free text search -->
    <ul class="margin-top">
      <li>
        <AccomodationsListUnitsList :units="allUnits" v-if="$store.state.accomodationsFilter.freeSearch" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccomodationsListPool from '@/components/parts/Accomodation/List/AccomodationsListPool';
import AccomodationsListUnitsList from '@/components/parts/Accomodation/List/AccomodationsListUnitsList';
import Note from '@/components/components/Note';

export default {
  components: {
    AccomodationsListPool,
    AccomodationsListUnitsList,
    Note,
  },
  props: ['pools', 'locations'],
  methods: {
    areaTitle(pool, index) {
      if (this.$store.state.accomodationsFilter.sorting && this.$store.state.accomodationsFilter.sorting.substr(0, 5) === 'site-') {
        if (index === 0) {
          return pool.units[0].facility.value;
        }

        const currentTitle = pool.units[0].facility.value;
        const previousTitle = this.filteredPools[index - 1].units[0].facility.value;

        if (currentTitle !== previousTitle) {
          return pool.units[0].facility.value;
        }
      }

      return '';
    },
  },
  computed: {
    ...mapGetters([
      'isAwaitingFilter',
    ]),
    showLocationLabel() {
      return this.$store.state.accomodationsFilter.sorting === 'site-2006'
        || this.$store.state.accomodationsFilter.sorting === 'site-2007'
        || this.$store.state.accomodationsFilter.sorting === 'site-2020';
    },
    filteredPools() {
      const berg = 2006;
      const by = 2007;
      const mattesdalen = 2020;
      const other = 2008;
      const currentSorting = this.$store.state.accomodationsFilter.sorting;

      const mapped = this.pools.map((pool) => {
        const newPool = Object.assign({}, pool);
        const current = pool.units[0].facility_id;
        const map = [];

        newPool.sort_order = 0;

        if (currentSorting) {
          if (currentSorting === `site-${berg}`) {
            map[`site-${berg}`] = 1;
            map[`site-${by}`] = 2;
            map[`site-${other}`] = 4;
            map[`site-${mattesdalen}`] = 3;
          } else if (currentSorting === `site-${by}`) {
            map[`site-${berg}`] = 2;
            map[`site-${by}`] = 1;
            map[`site-${other}`] = 4;
            map[`site-${mattesdalen}`] = 3;
          } else if (currentSorting === `site-${mattesdalen}`) {
            map[`site-${berg}`] = 2;
            map[`site-${by}`] = 3;
            map[`site-${other}`] = 4;
            map[`site-${mattesdalen}`] = 1;
          }

          if (map[`site-${current}`]) {
            newPool.sort_order = map[`site-${current}`];
          }
        }

        return newPool;
      });

      if (currentSorting === `site-${berg}`
          || currentSorting === `site-${by}`
          || currentSorting === `site-${mattesdalen}`) {
        return mapped.sort((a, b) => a.sort_order - b.sort_order);
      }

      return mapped.sort((a, b) => {
        if (currentSorting === 'price') {
          if (this.$store.state.accomodationsFilter.date.endDate && window.prices) {
            let currentLowestPrice = 9999999;
            let theOtherLowestPrice = 9999999;

            a.units.forEach((unit) => {
              if (window.prices[unit.id] && window.prices[unit.id]
                && window.prices[unit.id].price < currentLowestPrice) {
                currentLowestPrice = window.prices[unit.id].price;
              }
            });

            b.units.forEach((unit) => {
              if (window.prices[unit.id] && window.prices[unit.id]
                && window.prices[unit.id].price < theOtherLowestPrice) {
                theOtherLowestPrice = window.prices[unit.id].price;
              }
            });

            if (currentLowestPrice > theOtherLowestPrice) {
              return 1;
            }
            if (currentLowestPrice < theOtherLowestPrice) {
              return -1;
            }
            return 0;
          }
          if (a.price_from > b.price_from) {
            return 1;
          }
          if (a.price_from < b.price_from) {
            return -1;
          }
          return 0;
        }

        if (currentSorting === 'alphabetical') {
          const currentTitle = a.display_name || a.name;
          const theOtherTitle = b.display_name || b.name;
          if (currentTitle > theOtherTitle) {
            return 1;
          }
          if (currentTitle < theOtherTitle) {
            return -1;
          }
          return 0;
        }

        const negative = Math.round(Math.random());
        const number = Math.round(Math.random());

        return (negative ? (number * -1) : number);
      });
    },
    allUnits() {
      const units = [];
      this.pools.forEach((pool) => {
        pool.units.forEach((unit) => {
          units.push(unit);
        });
      });
      return units;
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.list-header
  margin-bottom: -10px
  margin-top: 40px
  padding-left 8px
  united-heavy()
  font-size size-font-3
  line-height size-font-3
  uppercase()
  border-radius: 2px
  background-color: #004d74
  color white
  padding space-1 space-1 space-half
  +max-tablet()
    border-radius: 0px

.margin-top
  margin-top space-3

.component
  transition-slide('animate-filter')
  transition all 0.3s
  &.waiting-for-filter
    disabled-grey()

ul.animate-list
  transition-list('animate-list')

.component
  max-width container-width
  margin-right auto
  margin-left auto

ul
  list-style none
  padding-left 0

.no-results
  border: solid 1px #bfd9e1;
  padding 20px
  background-color: #ecf5f8;
  float none
  margin 0 auto
  margin-top 30px
  max-width 600px
  opacity 0
  transform all 0.2s
  &.result-count-0
    opacity 1
  strong
    uppercase()
</style>



// WEBPACK FOOTER //
// AccomodationsList.vue?7653edf0